import { useEffect, useState } from 'react';
import { queryConfig } from '../api/queryBase';
import { QueryParameters } from '../pages/dashboard/bookings/createbooking/interfaces/QueryParameters';
import { PagingParams } from '../interfaces/Filter';

interface QueryParams<U> {
    params?: U;
    url: string;
    cacheKey?: string;
    enabled?: boolean;
}

export const useGetQuery = <T, U = QueryParameters>(args: QueryParams<U>) => {
    const { url, params, cacheKey, enabled } = args;
    const [entries, setEntries] = useState<T>([] as T);
    const [paging, setPaging] = useState<PagingParams>({
        total: 0,
        page: 1
    });

    const query = queryConfig();
    const { isLoading, data, isFetching, refetch, isError, error } = query<{
        content: T;
        totalElements?: number;
        total?: number;
        page?: number;
        number?: number;
    }>({
        url,
        cacheKey,
        params: { ...params },
        enabled
    });

    useEffect(() => {
        if (data) {
            setEntries(
                (data?.payload?.content || data?.payload || data || []) as T
            );
            setPaging((props) => ({
                ...props,
                total:
                    data?.payload?.totalElements || data?.payload?.total || 0,
                page: data?.payload?.page
                    ? data?.payload?.page
                    : data?.payload?.number
                    ? data?.payload?.number + 1
                    : 1
            }));
        }
    }, [isFetching, isLoading, data]);

    return {
        isLoading,
        entries,
        isFetching,
        refetch,
        paging,
        isError,
        error
    };
};
